/**
 * A defect is only sent to the API when the user picked a real option.
 *
 * 0 is the N/A option's value, and the dropdown also holds null when a stored defect_id matches
 * nothing in the current options — both mean "no defect". Anything non-numeric that reaches
 * `defect_id` comes back as a raw schema error and is toasted verbatim.
 */
// eslint-disable-next-line import/prefer-default-export
export const isSelectableDefect = value => Number.isInteger(Number(value)) && Number(value) > 0;
